import React from 'react'

import { IconSvgProps } from './icon'

export const IconChevronUpSmall: React.FC<IconSvgProps> = ({
    size = 24,
    color = 'var(--text-and-icon-primary)',
}) => {
    return (
        <svg
            fill='none'
            height={size}
            viewBox='0 0 24 24'
            width={size}
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                clipRule='evenodd'
                d='M17.7364 14.7364C17.3849 15.0879 16.8151 15.0879 16.4636 14.7364L12 10.2728L7.53639 14.7364C7.18492 15.0879 6.61507 15.0879 6.2636 14.7364C5.91213 14.3849 5.91213 13.8151 6.2636 13.4636L11.3636 8.36361C11.7151 8.01214 12.285 8.01214 12.6364 8.36361L17.7364 13.4636C18.0879 13.8151 18.0879 14.3849 17.7364 14.7364Z'
                fill={color}
                fillRule='evenodd'
            />
        </svg>
    )
}
